import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form"
export default class extends Controller {
  static values = { preventDoubleSubmit: Boolean }

  connect() {
    if (!this.preventDoubleSubmitValue) return

    this.submitting = false
    this.activeSubmission = null
    this.handleSubmitStart = this.handleSubmitStart.bind(this)
    this.handleSubmitEnd = this.handleSubmitEnd.bind(this)
    this.element.addEventListener("turbo:submit-start", this.handleSubmitStart)
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  disconnect() {
    if (!this.preventDoubleSubmitValue) return

    this.element.removeEventListener("turbo:submit-start", this.handleSubmitStart)
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  preventSubmit(event) {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }

  handleSubmitStart(event) {
    if (this.submitting) {
      this.cancelDuplicateSubmission(event.detail.formSubmission)
      return
    }

    this.submitting = true
    this.activeSubmission = event.detail.formSubmission
    this.disableSubmitButtons()
  }

  handleSubmitEnd(event) {
    if (!this.isActiveSubmission(event.detail.formSubmission)) return

    if (event.detail.success) {
      this.disableSubmitButtons()
      return
    }

    this.resetSubmissionState()
    this.enableSubmitButtons()
  }

  cancelDuplicateSubmission(formSubmission) {
    formSubmission.stop()
  }

  isActiveSubmission(formSubmission) {
    return formSubmission === this.activeSubmission
  }

  resetSubmissionState() {
    this.submitting = false
    this.activeSubmission = null
  }

  disableSubmitButtons() {
    this.submitButtons.forEach(button => { button.disabled = true })
  }

  enableSubmitButtons() {
    this.submitButtons.forEach(button => { button.disabled = false })
  }

  get submitButtons() {
    return this.element.querySelectorAll("button[type='submit'], input[type='submit']")
  }
}
